var _path, _path2, _g, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.939 32.425h-9.066a.938.938 0 0 1 0-1.875h9.066a.938.938 0 0 1 0 1.875Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "edit_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 8,
    width: 22,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 8.75h21.476v23.675H7.5V8.75Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#edit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.388 11.271 9.62 25.99a1.099 1.099 0 0 0-.214.944l.851 3.606 3.799-.048c.361-.004.695-.165.916-.44 4.021-5.031 11.688-14.623 11.905-14.905.205-.332.285-.802.178-1.255a1.764 1.764 0 0 0-.815-1.108 414.16 414.16 0 0 1-2.26-1.748c-.793-.635-1.95-.525-2.592.235ZM9.518 32.425a.938.938 0 0 1-.913-.721l-1.024-4.34a2.964 2.964 0 0 1 .575-2.546L19.93 10.091l.014-.016c1.29-1.544 3.626-1.772 5.2-.508l2.155 1.674c.76.453 1.353 1.261 1.578 2.219a3.577 3.577 0 0 1-.46 2.751c-.038.061-.072.114-11.982 15.014a3.058 3.058 0 0 1-2.358 1.142l-4.548.058h-.013Z",
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.28 19.606c-.2 0-.4-.064-.572-.194l-6.815-5.235a.939.939 0 0 1-.172-1.315.939.939 0 0 1 1.314-.171l6.817 5.234a.937.937 0 0 1-.573 1.681Z",
    fill: "#fff"
  })));
};
export default SvgEdit;